var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svgicon',{class:{ [_vm.$options.name]: true, 'default-size': _vm.defaultSize, 'small-size': _vm.small },attrs:{"data":_vm.renderContent,"fill":_vm.fill,"original":_vm.original,"aria-label":_vm.ariaLabel}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }